import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { pluck, map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from 'primeng/table';
import * as i3 from 'primeng/api';
import * as i4 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class FbEmployeeDetailsService {
    constructor(http) {
        this.http = http;
    }
    getEmployeeById(actualEmpId) {
        return this.http.get(`/vd/formBuilder/formData/${actualEmpId}/exitDetails`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
FbEmployeeDetailsService.ɵfac = function FbEmployeeDetailsService_Factory(t) { return new (t || FbEmployeeDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
FbEmployeeDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: FbEmployeeDetailsService, factory: FbEmployeeDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmployeeDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function FbEmployeeDetailsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Emp ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Employee Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Job Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Reporting Manager");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Employement Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Application Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Notice Period");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function FbEmployeeDetailsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.employeeId, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.employeeName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.companyName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.jobTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.reportingManager, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.employmentType, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(15, 9, rowData_r3 == null ? null : rowData_r3.resignationDate, "MM/dd/yy"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.noticePeriod, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r3 == null ? null : rowData_r3.status, " ");
} }
const _c0 = function () { return { "min-width": "30rem" }; };
class FbEmployeeDetailsComponent {
    constructor(fbEmployeeDetailsService) {
        this.fbEmployeeDetailsService = fbEmployeeDetailsService;
    }
    ngOnInit() {
        this.employeeId = sessionStorage.getItem("FbActualEmployeeId");
        if (this.employeeId) {
            this.getEmployeeData();
        }
    }
    getEmployeeData() {
        this.fbEmployeeDetailsService.getEmployeeById(this.employeeId)
            .pipe(take(1))
            .subscribe((response) => {
            this.items = [response] && [response].length > 0 ? [response] : [];
        });
    }
}
FbEmployeeDetailsComponent.ɵfac = function FbEmployeeDetailsComponent_Factory(t) { return new (t || FbEmployeeDetailsComponent)(i0.ɵɵdirectiveInject(FbEmployeeDetailsService)); };
FbEmployeeDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbEmployeeDetailsComponent, selectors: [["lib-fb-employee-details"]], decls: 4, vars: 3, consts: [[1, "employee-details-card"], [1, "exit-table", 3, "value", "tableStyle"], ["pTemplate", "header"], ["pTemplate", "body"]], template: function FbEmployeeDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p-table", 1);
        i0.ɵɵtemplate(2, FbEmployeeDetailsComponent_ng_template_2_Template, 19, 0, "ng-template", 2);
        i0.ɵɵtemplate(3, FbEmployeeDetailsComponent_ng_template_3_Template, 20, 12, "ng-template", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.items)("tableStyle", i0.ɵɵpureFunction0(2, _c0));
    } }, directives: [i2.Table, i3.PrimeTemplate], pipes: [i4.DatePipe], styles: [".exit-table[_ngcontent-%COMP%]{border-top:none!important}.exit-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding-bottom:0!important;background-color:#f8f9fa!important;color:#000!important;font-weight:400!important;font-size:14px!important}.exit-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-size:13px!important;color:#666;padding-top:0}.exit-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child{color:#5099e2}.exit-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child{border-bottom:1px solid #e9ecef}.exit-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{background-color:#f8f9fa!important;color:#2c2c2c!important;opacity:1!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmployeeDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-employee-details',
                templateUrl: 'fb-employee-details.component.html',
                styleUrls: ['fb-employee-details.component.scss']
            }]
    }], function () { return [{ type: FbEmployeeDetailsService }]; }, null); })();

class FbEmployeeDetailsModule {
}
FbEmployeeDetailsModule.ɵfac = function FbEmployeeDetailsModule_Factory(t) { return new (t || FbEmployeeDetailsModule)(); };
FbEmployeeDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbEmployeeDetailsModule });
FbEmployeeDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbEmployeeDetailsModule, { declarations: [FbEmployeeDetailsComponent], imports: [PrimengLibraryModule], exports: [FbEmployeeDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmployeeDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [FbEmployeeDetailsComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [FbEmployeeDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-employee-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbEmployeeDetailsComponent, FbEmployeeDetailsModule, FbEmployeeDetailsService };
//# sourceMappingURL=fb-employee-details.js.map
